export var DEPLOY_DATE = new Date('2026-10-08T12:54:15+0000');
